import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $failure, $requesting, $success } from "../form/action";
import { $processing, $done } from "services/activity/action";

export const MODULE = "Shipment";

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $cod = ActionCreator.Async(MODULE, "COD", () => {
  return async (dispatch) => {
    dispatch($processing($cod.OPERATION));

    return await Rest.GET(`${API_URL}/tms/delivery/shipment/cod/summary/driver`)
      .then((response) => {
        dispatch($cod.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($cod.OPERATION)));
  };
});

export const $show = ActionCreator.Async(MODULE, "Show", (id) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/tms/delivery/shipment/${id}`)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});

export const $console = ActionCreator.Async(
  MODULE,
  "Console",
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/delivery/shipment/${id}/console`,
        payload
      )
        .then((response) => {
          dispatch($console.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $disputed = ActionCreator.Async(
  MODULE,
  "Dispute",
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/delivery/shipment/${id}/dispute`,
        payload
      )
        .then((response) => {
          dispatch($disputed.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $delivered = ActionCreator.Async(
  MODULE,
  "Delivery",
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/delivery/shipment/${id}/delivered`,
        payload
      )
        .then((response) => {
          dispatch($delivered.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);
